export enum ProjectFilter {
  'All' = 'all-projects',
  'Starred' = 'starred-projects',
  'OwnedByMe' = 'projects-owned-by-me',
  'Shared' = 'shared-projects',
}
